import { getSessionId } from '@fs/zion-session'
import queryClient from '../queryClient'
import axios from './giveAxios'

const casSessionCheckUrl = '/service/ident/session/sessions'

// See https://familysearch.slack.com/archives/C06FR9QDBRB/p1749488876190089

export default async function checkUserSession() {
  try {
    return await queryClient.fetchQuery({
      queryKey: ['checkUserSession'],
      queryFn: async () => {
        const sessionId = getSessionId()
        if (!sessionId) {
          return { authenticated: false }
        }
        const resp = await axios.get(`${casSessionCheckUrl}/${sessionId}`, {
          headers: {
            Accept: 'application/session-v1+json',
          },
        })
        if (resp?.status === 200 && !!resp?.data?.userName) {
          return { authenticated: true }
        }
        return { authenticated: false }
      },
      cacheTime: 1000 * 60 * 10, // 10 minutes
      staleTime: 1000 * 60 * 10, // 10 minutes
    })
  } catch (error) {
    console.error('Error fetching data:', error)
    return { authenticated: false }
  }
}
